<!-- P6:1640-1655 -->
<h1 class="cx-h1">Career paths</h1>
<p class="cx-sub">Careers your confirmed tags fit, each profile built from current job postings. These are directions to explore, not openings to apply to.</p>

<div class="cx-paths">
  @for (card of Cards; track card.Match.roleRef) {
    <!-- The card is a click target for pointers; "Explore role" is the one keyboard/AT control (no nested role=link). -->
    <div class="cx-card cx-pc" (click)="Explore(card.Match.roleRef)">
      <div class="cx-pch">
        <span class="cx-ico" aria-hidden="true">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19 9 12l3.5 4L20 5"/><path d="M15 5h5v5"/></svg>
        </span>
        <span class="cx-st" [class.ok]="card.Badge.Tone === 'ok'" [class.near]="card.Badge.Tone === 'near'" [class.grey]="card.Badge.Tone === 'grey'">{{ card.Badge.Label }}</span>
      </div>
      <h3>{{ card.Match.title }}</h3>
      <div class="cx-mt"><span>Match</span><b>{{ card.PercentLabel }}</b></div>
      <!-- P6:445-447 striped .hi range bar is not built (one overlap on the wire): the solid fill only. -->
      <div class="cx-bar2" role="img" [attr.aria-label]="'Match ' + card.PercentLabel"><span class="lo" [style.width.%]="card.Percent"></span></div>
      <div class="cx-pcb">
        <div class="cx-rd">
          @for (seg of card.Readiness; track $index) {
            <!-- H-8: the plain segment sits in an ng-container so no template whitespace joins it ("Longer-term, needs…"); each segment carries its own leading space. -->
            @if (seg.strong) { <b>{{ seg.text }}</b> } @else { <ng-container>{{ seg.text }}</ng-container> }
          }
        </div>
        <div class="cx-cov">{{ card.Covered }}</div>
        @if (card.Held.length > 0) {
          <div class="cx-sk">
            @for (name of card.Held; track name) { <span>{{ name }}</span> }
            @if (card.More > 0) { <em>+{{ card.More }}</em> }
          </div>
        }
      </div>
      <button class="cx-link" type="button" [attr.aria-label]="'Explore role: ' + card.Match.title">
        Explore role
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
      </button>
    </div>
  }
</div>

<p class="cx-foot">{{ Footnote }}</p>
